import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from 'services/token/token.service';
import { Store } from '@ngrx/store';
import { Actions as BrandingActions } from 'features/organization-settings/platform-branding/+state/platform-branding.actions';
import {
  DEFAULT_CSS_VARIABLES_OBJECT_VALUE,
  updateCssVariables,
} from 'features/organization-settings/platform-branding/platform-branding.helpers';
import { DomainService } from 'services/domain/domain.service';
import { Actions as OrganizationLabelsActions } from 'features/global-organizations-setting-state/global-organizations-setting.actions';

@Component({
  selector: 'cm-logout',
  template: '',
  styleUrls: [],
})
export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private tokenService: TokenService,
    private domainService: DomainService,
    private store: Store<any>,
  ) {}

  ngOnInit() {
    this.tokenService.userLogout();
    if (!this.domainService.getDomainNameFromUrl()) {
      this.store.dispatch(new BrandingActions.Reset());
      this.store.dispatch(new OrganizationLabelsActions.Reset());
      updateCssVariables(DEFAULT_CSS_VARIABLES_OBJECT_VALUE);
    }
    this.router.navigate(['/entry/login']);
  }
}
